import {$, T} from "../../common/drupal/drupal";

class ParagraphMoreInfos {

    /**
     * Initialize event listeners
     */
    init () {
        // slide Paragraph more infos
        let slideInfosId = 0;
        let slideInfos = [];
        $('.ParagraphMoreInfos-infos:not(.swiper-container)').each(function () {
            $(this).addClass('swiper-container').find('.Taxo-further_informations').addClass('swiper-slide').wrapAll('<div class="swiper-wrapper"/>');
            $(this).append('<div class="swiper-button-prev"></div><div class="swiper-button-next"></div>');
            slideInfos[slideInfosId] = new Swiper($(this), {
                slidesPerView: 'auto',
                speed: 500,
                centerInsufficientSlides: true,
                watchOverflow: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            });
            slideInfosId++;
        });
    }

    attach(context) {
        this.init(context);
    }
}

export let paragraphMoreInfos = new ParagraphMoreInfos();
